<template>
  <div class="py-2 flex items-center justify-between border-t border-gray-200">
    <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
      <div>
        <p class="text-sm text-gray-700">
          Показано
          <span class="font-medium">{{ fromItem }}</span>
           -
          <span class="font-medium">{{ toItem }}</span>
          из
          <span class="font-medium">{{ totalRecords }}</span>
          записей
        </p>
      </div>
      <div v-if="lastPage > 1">
        <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
          <button @click.prevent="toPage(currentPage - 1)"
                  :disabled="currentPage === 1"
                  class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
            <ChevronLeftIcon class="h-5 w-5"/>
          </button>

          <button v-if="currentPage > 2"
                  @click.prevent="toPage(1)"
                  class="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 hidden md:inline-flex relative items-center px-4 py-2 border text-sm font-medium"> 1 </button>
          <button v-if="currentPage > 3"
                  @click.prevent="toPage(getMiddlePage(1, currentPage))"
                  class="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700"> ... </button>
          <button v-if="currentPage > 1"
                  @click.prevent="toPage(currentPage - 1)"
                  class="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 hidden md:inline-flex relative items-center px-4 py-2 border text-sm font-medium">
            {{ currentPage - 1 }}
          </button>

          <span class="z-10 border-indigo-500 text-blue-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"> {{ currentPage }} </span>

          <button v-if="lastPage !== currentPage"
                  @click.prevent="toPage(currentPage + 1)"
                  class="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 hidden md:inline-flex relative items-center px-4 py-2 border text-sm font-medium">
            {{ currentPage + 1 }}
          </button>
          <button v-if="lastPage - currentPage > 2"
                  @click.prevent="toPage(getMiddlePage(currentPage, lastPage))"
                  class="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700"> ... </button>
          <button v-if="lastPage - currentPage > 1"
                  @click.prevent="toPage(lastPage)"
                  class="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium">{{ lastPage }} </button>

          <button @click.prevent="toPage(currentPage + 1)"
                  :disabled="currentPage === lastPage"
                  class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
            <ChevronRightIcon class="h-5 w-5"/>
          </button>
        </nav>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Pagination',
  props: ['value', 'limit', 'totalRecords'],
  data() {
    return {
      currentPage: this.value
    }
  },
  computed: {
    fromItem() {
      return this.limit * (this.currentPage - 1) + 1
    },
    toItem() {
      return (this.limit * this.currentPage) < this.totalRecords ? (this.limit * this.currentPage) : this.totalRecords
    },
    lastPage() {
      return Math.ceil(this.totalRecords/this.limit)
    }
  },
  watch: {
    value(val) {
      this.currentPage = val
    }
  },
  methods: {
    toPage(page) {
      this.$emit('change', page);

      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 100);
    },
    getMiddlePage(first, second) {
      return Math.floor((second - first) / 2 + first);
    }
  }
}
</script>